import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";
import { ShieldCheck } from "lucide-react";
import { formatDateTime } from "@/lib/format";

export default function AuditPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await api.get("/audit-logs"); setItems(r.data); }
      catch (_e) { void _e; } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <header>
        <p className="text-xs uppercase tracking-widest text-muted-foreground font-medium">Segurança</p>
        <h1 className="font-heading text-3xl font-bold mt-1">Auditoria</h1>
        <p className="mt-1 text-sm text-muted-foreground">Registro imutável de todas as ações do sistema.</p>
      </header>
      <Card>
        <CardContent className="p-0">
          {loading ? (
            <div className="p-6 space-y-2">{Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-10 rounded" />)}</div>
          ) : items.length === 0 ? (
            <div className="p-12 text-center text-sm text-muted-foreground">
              <ShieldCheck className="mx-auto mb-3 text-muted-foreground/50" /> Nenhum registro ainda.
            </div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Data/Hora</TableHead>
                  <TableHead>Ação</TableHead>
                  <TableHead>Usuário</TableHead>
                  <TableHead>Entidade</TableHead>
                  <TableHead>IP</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {items.map((i) => (
                  <TableRow key={i.id} data-testid={`audit-row-${i.id}`}>
                    <TableCell className="text-xs text-muted-foreground whitespace-nowrap">{formatDateTime(i.created_at)}</TableCell>
                    <TableCell><span className="text-xs font-mono px-2 py-0.5 rounded bg-muted">{i.action}</span></TableCell>
                    <TableCell className="text-sm">{i.user_email || "-"}</TableCell>
                    <TableCell className="text-xs text-muted-foreground">{i.entity || "-"} {i.entity_id && <span className="opacity-70">#{i.entity_id.slice(0, 8)}</span>}</TableCell>
                    <TableCell className="text-xs font-mono">{i.ip || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
